import { makeObservable, observable, runInAction } from "mobx";
import { ViewModelBase } from "@shoothill/core";
import { StudentSessionAQACertificateModel, StudentSessionAQACertificateModelValidator } from "./StudentSessionAQACertificateModel";
import { RelayCommand } from "Application";
import { ViewMode } from "Views/Shared/Interfaces/IViewMode";

export class StudentSessionAQACertificateViewModel extends ViewModelBase<StudentSessionAQACertificateModel> {
    public viewMode: ViewMode = new ViewMode("add");
    constructor(model: StudentSessionAQACertificateModel) {
        super(model);
        this.setValidator(new StudentSessionAQACertificateModelValidator());
        makeObservable(this, {});
    }

    //#region computed values

    public get description() {
        return this.model.description;
    }

    //#region Commands

    public updateDescriptionCommand = new RelayCommand((v: string) => {
        this.setValue("description", v);
    });
}
